import { Row, Col } from "antd";
import { forwardRef, useState } from "react";
import { isNil } from "lodash";
import Container from "shared/components/Container";
import Input from "shared/components/Input";
import Button from "shared/components/Button";
import Dropdown from "shared/components/Dropdown";
import { ArrowRightIcon, CaretDownIcon } from "@phosphor-icons/react";
import { NAME_SPACES } from "shared/locales/constants";
import { useTranslation } from "react-i18next";
import graphql from "utils/api/graphql";
import { CHAIN_TYPES } from "utils/constants";
import Typography from "shared/components/Typography";
import { getAssetIcon } from "utils/helpers/assets";

const displays = {
  selected: forwardRef(({ item, ...props }, ref) => {
    if (isNil(item)) return null;

    const icon = getAssetIcon(item.type);
    const label = item.type;
    return (
      <div ref={ref} {...props} className="dropdown__display--trigger">
        <span className="dropdown__display--trigger--icon">{icon}</span>
        <span className="dropdown__display--trigger--label">{label}</span>
        <CaretDownIcon size={20} />
      </div>
    );
  }),
  unselected: forwardRef(({ item, ...props }, ref) => {
    const icon = getAssetIcon(item.type);
    const label = item.type;
    const name = "United States Dollar";
    return (
      <div ref={ref} {...props} className="dropdown__option--option">
        <span className="dropdown__option--option-icon">{icon}</span>
        <div className="dropdown__option--option-info">
          <div className="dropdown__option--option-info-label">{label}</div>
          <div className="dropdown__option--option-info-value">{name}</div>
        </div>
      </div>
    );
  }),
};

const View = ({ onSubmit, setData, data }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const REPLENISH = t("REPLENISH", { returnObjects: true });
  const [selectedAmountCurrency, setSelectedAmountCurrency] = useState(null);
  const isDisabled =
    isNil(data.debtor) || isNil(data.amount) || isNil(data.currency);

  const onAmountChange = (e) => {
    const updatedData = { ...data, amount: e.target.value };
    setData(updatedData);
  };

  const onCurrencyChange = (selectedCurrency) => {
    setSelectedAmountCurrency(selectedCurrency);
    const updatedData = {
      ...data,
      currency: selectedCurrency.token?.type,
      amountCurrency: selectedCurrency.token,
    };
    setData(updatedData);
  };

  return (
    <Container>
      <Row justify="center" gutter={[16, 16]}>
        <Col xs={24} sm={24} md={14} lg={14} xl={14} xxl={14}>
          <div className="section__wrapper">
            <Typography size="lg" color="black" position="center">
              {REPLENISH.TITLE}
            </Typography>
            <div className="section__wrapper--fields">
              <div className="section__wrapper--field">
                <Input
                  label={REPLENISH.FORM.FIELDS.AMOUNT}
                  type="number"
                  variant="amount"
                  onChange={onAmountChange}
                  placeholder={"0,00"}
                  suffix={
                    <Dropdown
                      displays={displays}
                      value={selectedAmountCurrency}
                      defaultValue="first"
                      node={[
                        graphql.queries.TOKENS,
                        { variables: { where: { chain: CHAIN_TYPES.FIAT } } },
                        "tokens.data",
                      ]}
                      searchFields={["type", "name"]}
                      renderAsInput={false}
                      onSelect={onCurrencyChange}
                    />
                  }
                />
              </div>
            </div>
            <div className="section__wrapper--actions">
              <Button
                icon={<ArrowRightIcon size={20} />}
                iconPosition="right"
                disabled={isDisabled}
                onClick={onSubmit}
              >
                {REPLENISH.FORM.ACTIONS.CONTINUE}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default View;
